import { Directive, ElementRef, EventEmitter, NgZone, Output } from "@angular/core";
import { ɵNzTabScrollListDirective } from "ng-zorro-antd/tabs";
import { UiTabScrollEvent, UiTabScrollListOffsetEvent } from "../models/tab.models";

@Directive({
  selector: "[uiTabScrollList]",
})
export class UiTabScrollListDirective extends ɵNzTabScrollListDirective {
  @Output() public readonly offsetChange = new EventEmitter<UiTabScrollListOffsetEvent>();
  @Output() public readonly tabScroll = new EventEmitter<UiTabScrollEvent>();

  constructor(ngZone: NgZone, elementRef: ElementRef<HTMLElement>) {
    super(ngZone, elementRef);
  }
}
